/**
 * This file is part of "Zona franca"
 * Copyright (c) 2022
 * Zona franca
 * All rights reserved
 *
 * @author Turiano Romero <https://bitbucket.org/rome9603/ | tromero@technisupport.com>
 * @version 2.0
 */

import { authTypes } from "redux/types";

const initialState = {
  dataUser: null,
  isLogged: false
};

export const authenticationReducer = (state = initialState, action) => {
  switch (action.type) {
    case authTypes.login:
      return {
        ...state,
        dataUser: action.payload,
        isLogged: true,
        sessionExpired: false
      };

    case authTypes.logout:
      return {
        ...state,
        dataUser: null,
        isLogged: false,
        sessionExpired: false
      };

    case authTypes.updateFreeZone:
      return {
        ...state,
        dataUser: {
          ...state.dataUser,
          ...action.payload
        },
        name_freeZone: action.payload?.name_freeZone
      };
    case authTypes.renewToken:
      return {
        ...state,
        dataUser: {
          ...state.dataUser,
          ...action.payload
        }
      };
    case authTypes.sessionExpired:
      return {
        ...state,
        dataUser: null,
        isLogged: false,
        sessionExpired: true
      }

    default:
      return state;
  }
};
